/**
 * Auto Update Service
 *
 * Polls Cloud Run for a deploy version bump (platform_settings appVersion)
 * and reloads when a new service worker takes control.
 */
import { getPublicAppVersion } from '../api/system/systemStatus';

const VERSION_POLL_MS = 60 * 1000;

export const initializeAutoUpdate = () => {
  const cleanupFunctions = [];

  cleanupFunctions.push(initializeVersionPolling());
  if ('serviceWorker' in navigator) {
    cleanupFunctions.push(initializeServiceWorkerUpdates());
  }

  return () => {
    cleanupFunctions.forEach((cleanup) => cleanup());
  };
};

function applyVersion(payload) {
  if (!payload || typeof payload !== 'object') return;
  if (payload.version) localStorage.setItem('appVersion', String(payload.version));
  if (payload.cacheKey) localStorage.setItem('lastCacheKey', String(payload.cacheKey));
  if (payload.invalidationKey) localStorage.setItem('lastInvalidationKey', String(payload.invalidationKey));
}

function initializeVersionPolling() {
  let cancelled = false;
  const poll = async () => {
    try {
      const payload = await getPublicAppVersion();
      if (!cancelled) applyVersion(payload);
    } catch (error) {
      console.warn('[auto-update] version poll failed', error);
    }
  };
  void poll();
  const interval = setInterval(() => {
    void poll();
  }, VERSION_POLL_MS);
  return () => {
    cancelled = true;
    clearInterval(interval);
  };
}

function initializeServiceWorkerUpdates() {
  const updateInterval = setInterval(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.update();
        });
      });
    }
  }, 60 * 60 * 1000);

  const onControllerChange = () => {
    window.location.reload();
  };
  navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);

  return () => {
    clearInterval(updateInterval);
    navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
  };
}
